import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/api';
import type { ConversationWithUnread } from '@/types';

/**
 * Hook to fetch all conversations with unread counts.
 * Automatically refetches when returning to the page.
 */
export function useConversations() {
  return useQuery<ConversationWithUnread[]>({
    queryKey: ['chat', 'conversations'],
    queryFn: () => api.chat.getConversations(),
    staleTime: 1000 * 30, // 30 seconds
    refetchOnWindowFocus: true, // Refetch when user returns to the app
  });
}
